export default __webpack_public_path__ + "static/media/ShieldCheck.55419378.svg";